import { isArticleTileViewModel } from '@rocco/ui/tile-article/view-models/article';
import { isProfessionalTileViewModel } from '@rocco/ui/tile-professional/view-models/professional';
import { isProjectTileViewModel } from '@rocco/ui/tile-project/view-models/project';
import { isProductTileViewModel } from '@rocco/ui/tile-product/view-models/product';
import type { TileableModel } from '@rocco/ui/tile-shared/view-models/tile';
import type { TileVisitWebsiteConfig } from '../components/TileActionPanel';

/**
 * The tile's "Visit site" target, or null when it has no website — the tile
 * types that carry one are product, project, professional and article, and
 * only on surfaces whose loader fetched it.
 *
 * A product's or project's site is its supplier's; an article's is that of the
 * practice that published it. Either way the referral is attributed to that
 * professional, which is the whole point of tracking it.
 *
 * Product must be checked before project: the duck-typed guards overlap.
 */
export const buildTileVisitWebsite = (
    model: TileableModel,
): TileVisitWebsiteConfig | null => {
    if (!('website' in model) || !model.website) {
        return null;
    }

    if (isProductTileViewModel(model) || isProjectTileViewModel(model)) {
        return {
            website: model.website,
            libraryItemID: model.id,
            professionalID: model.professional?.id ?? 0,
            professionalTitle: model.professional?.name ?? '',
        };
    }

    if (isProfessionalTileViewModel(model)) {
        return {
            website: model.website,
            libraryItemID: model.id,
            professionalID: model.id,
            professionalTitle: model.title,
        };
    }

    if (isArticleTileViewModel(model)) {
        return {
            website: model.website,
            libraryItemID: model.id,
            professionalID: model.professional?.id ?? 0,
            professionalTitle: model.professional?.name ?? '',
        };
    }

    return null;
};
